module.exports = __webpack_public_path__ + "static/media/history_21.c8d8adcd.jpg";